import { 
    Base,
    handleOpacity
 } from '../index.js'

export default class Color extends Base {
    constructor(options) {
        super(options)

        const defaults = {
            type: 'solid',
            val: '#C4C4C4',
            color: {
                r: 196,
                g: 196,
                b: 196
            }
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.val = opts.val
        this.color = opts.color
    }

    set(key, newValue) {
        let config = {
            val: () => {
                if (Color.isValidHex(newValue)) {
                    this.val = Color.formatHex(newValue).toUpperCase()
                    this.color = Color.hexToRgb(this.val)
                    return this.val
                } 
                return this.val
            },
            opacity: handleOpacity,
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatchToParent('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
           Base.prototype.set.call(this, key, newValue)
        }
    }

    remove() {
        this.set('deleted', true)
        this.dispatchToParent('objectStateChanged', this.propertyChangedMessage('Color deleted'))
    }

    mixRgbColors(added) {
        const base = this.getRgbAlphaAsArray();
        added = added.getRgbAlphaAsArray();

        base[3] = base[3] / 100
        added[3] = added[3] / 100

        const mix = [];
        mix[3] = 1 - (1 - added[3]) * (1 - base[3]); // alpha
        mix[0] = Math.round((added[0] * added[3] / mix[3]) + (base[0] * base[3] * (1 - added[3]) / mix[3])); // red
        mix[1] = Math.round((added[1] * added[3] / mix[3]) + (base[1] * base[3] * (1 - added[3]) / mix[3])); // green
        mix[2] = Math.round((added[2] * added[3] / mix[3]) + (base[2] * base[3] * (1 - added[3]) / mix[3])); // blue

        const alpha = mix[3]
        mix.pop()
        return { color: mix, alpha }
    }

    static isValidHex(hex) {
        var reg = /^#([0-9a-f]{3}){1,2}$/i;
        return reg.test(hex)
    }

    static formatHex(hex) {
        if (this.isValidHex(hex)) {
            if (hex.length == 4) {
                return this.convertHexToSix(hex)
            }
            return hex
        }
    }

    static convertHexToSix(hex) {
        hex = hex.split("").map((item) => {
            if (item == "#") { return item }
            return item + item;
        }).join("")

        if (hex[0] != "#") {
            hex = "#" + digit;
        }

        return hex
    }

    static rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    static hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    getRgbAlphaAsArray() {
        return [this.color.r, this.color.g, this.color.b, this.opacity]
    }

    static convertRbgArrayToObject(rgbArray) {
        return {
            r: rgbArray[0],
            g: rgbArray[1],
            b: rgbArray[2]
        }
    }
}